import { FunctionComponent } from 'react'
import { MdSearch } from 'react-icons/md'

import { Grid } from '@material-ui/core'
import * as Yup from 'yup'

import Button from '../../../shared/components/Button'
import { colors } from '../../../shared/styles/colors'
import { IBuscarProps } from './BuscarComponent.types'
import { FormWrapper, StyledForm, StyledInput } from './styles'

const Buscar: FunctionComponent<IBuscarProps> = ({
  handleSubmit,
  inputBuscarRef,
  placeholder,
  label,
  loading,
}) => {
  return (
    <>
      <StyledForm
        onSubmit={values => handleSubmit({ valueInput: values.valueInput })}
        initialValues={{
          valueInput: '',
        }}
        validationSchema={() => ({
          valueInput: Yup.string(),
        })}
      >
        {formControl => (
          <FormWrapper>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item lg={8} xs={12}>
                <StyledInput
                  ref={inputBuscarRef}
                  placeholder={placeholder}
                  name="valueInput"
                  type="text"
                  formControl={formControl}
                  label={label}
                />
              </Grid>
              <Grid item lg={4} xs={12}>
                <Button
                  color={colors.green}
                  type="submit"
                  onClick={formControl.handleSubmit}
                  loading={loading}
                >
                  <MdSearch /> Buscar
                </Button>
              </Grid>
            </Grid>
          </FormWrapper>
        )}
      </StyledForm>
    </>
  )
}

export default Buscar
